'use strict';

import React from 'react';
import PubSub from 'pubsub-js';
import StreetView from './StreetView';
import Footer from './Footer';
import Infos from './Infos';


class Section extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			SPOTS: null,
			status: null
		}
	}

	componentDidMount(){
		PubSub.subscribe('STATUS', (e,d) => {
			//console.log(d.type)
			this.setState({
				status: d.type
			});
		});
	}

	render() {
		//console.log(this.state.status)
		let loadingClass = 
		this.state.status != "TELEPORT_DONE" ?
		"is-loading" :
		"is-loaded";

		if(!this.state.status)loadingClass = "is-init"

console.log("-----------", loadingClass)
		return (
			<section className={loadingClass}>
				<StreetView spots={this.props.spots} />
				
				<Footer spots={this.props.spots} />
				<div id="loader" className={loadingClass}>
				    <div id="hyperspace">
				        <meta itemProp="image" content="https://t-e-l-e-p-o-r-t.me/images/teleport-image.jpg" />
				        <meta itemProp="thumbnailUrl" content="https://t-e-l-e-p-o-r-t.me/images/teleport-image.jpg" />
				    </div>
				    <div id="trame"></div>
				</div>
			</section>
		);
	}
}

Section.displayName = 'Section';

// Uncomment properties you need
// SectionComponent.propTypes = {};
// SectionComponent.defaultProps = {};

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section.js